module.exports = __webpack_public_path__ + "sunsemweb/img/ban.36a33030.png";